// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"a03c8a29","492":"228b3744"}[chunkId] + ".chunk.js";
};